module.exports = __webpack_public_path__ + "img/warning.087a026e.svg";